export interface PatchNote {
    date: Date
    version: number
    contents: PatchNoteContent[]
}

export interface PatchNoteContent {
    type: PatchNoteType
    description: string
    contributors: string[]
    beforeImgUrl: string | undefined
    afterImgUrl: string | undefined
    links: string[] | undefined
}

export enum PatchNoteType {
    Feature = 'Feature',
    Update = 'Update',
    Blog = 'Blog',
    Fix = 'Fix',
    Category = 'Category',
    Youtube = 'YouTube',
}

export function getPatchNote(year: number, month: number, day: number, v: number, contents: PatchNoteContent[]) {
    return {
        date: new Date(year, month - 1, day), // We add -1 because Month 0 = Jan, Month 1 = Feb
        version: v,
        contents: contents,
    }
}

export function getContent(type: PatchNoteType, description: string, contributors?: string[],
                           beforeImgUrl?: string, afterImgUrl?: string, links?: string[]): PatchNoteContent {
    return {
        type: type,
        description: description,
        contributors: contributors == undefined ? [] : contributors,
        beforeImgUrl: beforeImgUrl,
        afterImgUrl: afterImgUrl,
        links: links,
    }
}
